(() => {
  'use strict';
  const VERSION = 'AW-BRAND-HANDLE-NORMALIZER-P2-V8-20260913';
  const node = document.getElementById('aw-brand-comparator-data');
  if (!node) return;
  try {
    const payload = JSON.parse(node.textContent || '{}');
    let normalized = 0;
    (Array.isArray(payload.brands) ? payload.brands : []).forEach((brand) => {
      try {
        const url = new URL(String(brand.url || ''), window.location.origin);
        const parts = url.pathname.split('/').filter(Boolean);
        const handle = decodeURIComponent(parts[parts.length - 1] || '').trim();
        if (handle) {
          brand.handle = handle;
          normalized += 1;
        }
      } catch (_) {}
    });
    node.textContent = JSON.stringify(payload);
    node.dataset.awHandleNormalizer = VERSION;
    const root = document.getElementById('aw-brand-compare');
    if (root) root.dataset.awHandleNormalizer = `${VERSION}:${normalized}`;
  } catch (error) {
    console.warn('[AW Brand Handle Normalizer V8] invalid payload', error);
  }
})();
